import { makeAutoObservable, runInAction } from "mobx";
export class PCheckout {
    constructor(params) {
        this.purchaseOrder = params.purchaseOrder;
        this.restaurant = params.restaurant;
        this.locale = params.locale;
        this.checkoutService = params.checkoutService;
        this.orderDetails = params.orderDetails;
        this.fulfillmentFormController = params.fulfillmentFormController;
        this.paymentFormController = params.paymentFormController;
        this.contactFormController = params.contactFormController;
        this.consentsFormController = params.consentsFormController;
        this.invoiceFormController = params.invoiceFormController;
        this.placeOrderCallback = params.placeOrderCallback;
        this.isSubmitted = false;
        this._isLoading = false;
        this._serverErrors = [];
        makeAutoObservable(this);
    }
    // TODO: get more detailed front-end errors
    get formInvalid() {
        return this.isSubmitted && !this.purchaseOrder.isCheckoutFormValid;
    }
    get isLoading() {
        return this._isLoading;
    }
    get enableMarketingConsents() {
        return this.restaurant.enableMarketingConsents;
    }
    get hasMarketingConsentError() {
        return (this.orderDetails.doesAnyPromotionRequireMarketingConsents &&
            !this.purchaseOrder.isAgreedToMarketingConsents);
    }
    get price() {
        return this.purchaseOrder.price;
    }
    get alternativePrice() {
        return this.purchaseOrder.alternativePrice;
    }
    get serverErrors() {
        return this._serverErrors;
    }
    get error() {
        return this.purchaseOrder.error;
    }
    get fulfillmentMethods() {
        return this.purchaseOrder.fulfillmentMethods;
    }
    get orderLines() {
        return this.purchaseOrder.orderLines;
    }
    get paymentMediums() {
        var _a;
        return ((_a = this.restaurant.paymentMediums) === null || _a === void 0 ? void 0 : _a.raw) || [];
    }
    get selectedPaymentMedium() {
        const domain = this.purchaseOrder.paymentMedium;
        if (domain === null) {
            return null;
        }
        const medium = this.paymentMediums.find((medium) => medium.isSelected(domain)) || null;
        if (medium === null) {
            return null;
        }
        return medium.kind === "OnlineGroup" ? medium.getChannel(domain) : medium;
    }
    get isOnlinePayment() {
        return (this.selectedPaymentMedium !== null &&
            this.selectedPaymentMedium.kind === "SingleChannel");
    }
    get contactDetailsLocked() {
        return this.purchaseOrder.contactDetailsLocked;
    }
    get restaurantFranchiseName() {
        return this.restaurant.franchiseName;
    }
    get restaurantOpeningHour() {
        return this.restaurant.openingHour;
    }
    get promotions() {
        return this.orderDetails.promotionInstances;
    }
    disableMarketingPromotionInstances() {
        this.orderDetails.disableMarketingPromotionInstances();
    }
    unlockContactDetails() {
        this.purchaseOrder.unlockContactDetails();
    }
    get isPaymentMediumRestored() {
        return this.purchaseOrder.isPaymentMediumRestored;
    }
    get canPlaceOrder() {
        return this.purchaseOrder.canPlaceOrder;
    }
    // Used only to show debug info
    get availability() {
        return this.purchaseOrder.availability;
    }
    async placeOrder(appOriginPath) {
        this.isSubmitted = true;
        this.fulfillmentFormController.submit();
        this.paymentFormController.submit();
        this.contactFormController.submit();
        this.invoiceFormController.submit();
        this.consentsFormController.submit();
        if (!this.canPlaceOrder || this.isLoading) {
            return;
        }
        runInAction(() => {
            this._isLoading = true;
        });
        const req = this.purchaseOrder.checkoutData({
            appOrigin: appOriginPath,
            locale: this.locale,
        });
        const res = await this.checkoutService.checkout(req);
        if (res.tag === "Errors") {
            runInAction(() => {
                this._isLoading = false;
                this._serverErrors = res.contents;
            });
        }
        this.placeOrderCallback(res);
    }
}
